let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fd7Gg")).then(() => parcelRequire('6wUJL'));